import { type FlagCode } from '../components/Icon/Flag'

export const APP_STORE_URL = 'https://apps.apple.com/us/app/nova-post/id1644647080'
export const GOOGLE_PLAY_URL = 'https://play.google.com/store/apps/details?id=eu.novapost'

const NOVA_POST_LOCALES: Record<string, string> = {
  cs: 'cs-cz',
  en: 'en-cz',
  uk: 'uk-cz',
}

const DEFAULT_NOVA_POST_LOCALE = NOVA_POST_LOCALES.uk

const resolveNovaPostLocale = (language: string) => {
  const baseLanguage = language.split('-')[0].toLowerCase()

  return NOVA_POST_LOCALES[baseLanguage] ?? DEFAULT_NOVA_POST_LOCALE
}

export const getNpShoppingBuyInUaUrl = (language: string) =>
  `https://novapost.com/${resolveNovaPostLocale(language)}/npshopping/buy-in-ua?tab=personal`

export const getPrivacyPolicyUrl = (language: string) =>
  `https://novapost.com/${resolveNovaPostLocale(language)}/more/privacy-policy`

export interface CountryCode {
  code: string
  flag: FlagCode
  /** Phone mask, `0` marks a digit slot */
  mask: string
}

export const COUNTRY_CODES: CountryCode[] = [
  { code: '+420', flag: 'cz', mask: '000 000 000' },
  { code: '+380', flag: 'ua', mask: '00 000 00 00' },
]
